import { MouseEvent } from 'react';
import { ContextMenuProps } from 'app/components/ChakraTableList/ContextMenu/types';
import { ContextMenuOption } from 'types/general.types';

export const contextMenuHandler = (
  e: MouseEvent<HTMLDivElement | HTMLButtonElement>,
  contextMenuProps: ContextMenuProps,
  options: ContextMenuOption[]
) => {
  const isRightClick = e.type === 'contextmenu';
  contextMenuProps.setOptions(options);
  const { x, y, width } = (e.target as HTMLElement)?.getBoundingClientRect();

  contextMenuProps.setPosition(
    isRightClick
      ? { x: e.clientX, y: e.clientY }
      : {
          x: x + width,
          y: y + 20,
        }
  );
  e.preventDefault();
  e.stopPropagation();
};
